import React from "react";
import { forwardRef } from "react";
import NumberFormat from "react-number-format";

export default forwardRef(function CurrencyFormat(props, ref) {
  const { onChange = () => {}, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator
      isNumericString
      decimalScale={2}
      prefix="$"
    />
  );
});
